import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FirebaseService } from '../services/auth/firebase.service';

const WORKERS_BLOCKED_PATTERNS: string[] = [
  '/orders', //Ordenes
  '/gamas' //Gamas
]

export const firebaseGuard: CanActivateFn = async (route, state) => {
  const firebaseService = inject(FirebaseService)
  const router = inject(Router)

  if(!firebaseService.user.email) {
    try{
      //Si no hay email no hay usuario
      await firebaseService.verifyUser() 
    }
    catch(error){
      console.error(error)
    }
  }

  console.log('URL que analiza el guard:' + state.url)
  const is_auth: boolean = await firebaseService.isAuth()

  //Si no hay usuario logueado se redirige a login
  if(!is_auth){
    return router.createUrlTree(['/auth/login'])
  }

  //Si hay usuario logueado y la URL es de login o de registro se redirige a la pagina principal
  else if(is_auth && (state.url === '/auth/login' || state.url === '/auth/register')){
    return router.createUrlTree(['/orders'])
  }

  //Si esta logueado
  else {
    //Rutas vetadas para workers
    if(firebaseService.user.role !== 'administrator' && WORKERS_BLOCKED_PATTERNS.some(pattern => state.url.match(pattern))) return router.createUrlTree(['/actions/create/new'])

    //Si no hay problema, se permite el acceso
    return true
  }
};
